<script>
import _ from 'lodash';

import { authComputed, authMethods, clientComputed, clientMethods, trainerComputed } from '@state/helpers';

export default {
  name: 'PersonalInformationMobile',
  components: {},
  data() {
    return {
      goal: '',

      updatingClient: false,
    };
  },
  mounted() {
    this.initalizeLocalState();
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    initalizeLocalState() {
      this.goal = this.userMainGoal;
    },
    async handleSubmitPersonalGoal() {
      this.updatingClient = true;

      const payload = {
        client: {
          profile: this.userProfile,
          progress: {
            ...this.userProgress,
          },
        },
      };

      payload.client.progress.goals.customGoals[0] = this.goal;
      const response = await this.updateClient({ clientId: this.clientId, trainerId: this.trainerId, payload });

      if (response.success === false) {
        console.error('response: ', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.client;
        this.setCurrentUser(updatedUser);

        if (this.goal === 'Other') {
          await this.updateOnboardingProgress(2);
          this.$router.push({ name: 'personalMotivation' }).catch((err) => {
            if (err !== undefined) {
              console.error(err);
            }
          });
        } else {
          await this.updateOnboardingProgress(3);
          this.$router.push({ name: 'personalCurrentWeight' }).catch((err) => {
            if (err !== undefined) {
              console.error(err);
            }
          });
        }
      }

      this.updatingClient = false;
    },
    handleRadioClick(event) {
      this.goal = event;
    },
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    ...trainerComputed,
  },
};
</script>

<template>
  <div class="page">
    <div class="container">
      <div class="header">
        <BaseProgressBar :limit="7" :progress="2" class="base-progress-bar" />
        <div class="title">
          <h1>What’s your <br />goal?</h1>
        </div>
      </div>
      <div class="form">
        <form>
          <div class="radio">
            <BaseInputRadioButton
              message="Build Muscle"
              :id="1"
              classStyle="container-radio"
              :checked="goal === 'Build Muscle'"
              :onClick="() => handleRadioClick('Build Muscle')"
            />
            <BaseInputRadioButton
              message="Lose Weight"
              :id="2"
              classStyle="container-radio"
              :checked="goal === 'Lose Weight'"
              :onClick="() => handleRadioClick('Lose Weight')"
            />
            <BaseInputRadioButton
              message="Other"
              :id="3"
              classStyle="container-radio"
              :checked="goal === 'Other'"
              :onClick="() => handleRadioClick('Other')"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="buttons">
      <div id="back">
        <router-link to="/signup/personal-information">
          <BaseButton class="large-transparent">
            <img src="@assets/images/icons/left-arrow.svg" />
            Back
          </BaseButton>
        </router-link>
      </div>
      <div id="next">
        <BaseButton class="large" @click="handleSubmitPersonalGoal" :disabled="goal === '' || updatingClient">
          Next
          <img src="@assets/images/icons/right-arrow.svg" />
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.page {
  width: 100%;
  .container {
    background: white;
    padding-bottom: 10rem;
    width: 100%;
    .header {
      margin: 0;
      text-align: start;
      width: 100%;

      .base-progress-bar {
        margin-left: 6.4%;
        margin-top: 19.2%;
        width: 87.2%;
      }

      .title {
        align-self: center;
        font-family: $base-font-family;
        font-size: 18px;
        width: 100%;

        h1 {
          color: black;
          font-size: 36px;
          letter-spacing: -0.761905px;
          line-height: 42px;
          margin: 17.8% 9.75% 0 6.4%;
        }
      }
    }

    .form {
      display: block;
      margin: 0;
      margin-top: 18.5%;
      text-align: center;
      width: 100%;

      .radio {
        margin-left: 9.25%;
        width: 81.75%;
      }

      form {
        height: 100%;
        width: 100%;
      }
    }
  }
  .buttons {
    background-color: white;
    bottom: 0;
    position: fixed;
    right: 0;
    width: 100%;
    button:disabled {
      background-color: lighten($color: #4059e1, $amount: 20);
    }
    #next {
      float: right;
      margin-bottom: 4rem;
      margin-left: auto;
      margin-right: 5%;
      width: 40%;
    }
    #back {
      float: left;
      margin-right: 9%;
      width: 34.75%;
      .large-transparent {
        color: #000;
      }
    }
  }
}
</style>
